import type { AmbleContent } from "../..";
import { goCompareTermsOfPolicy } from "../../shared/terms-of-policy";

export const ambles: Record<string, AmbleContent> = {
  terms_of_policy: goCompareTermsOfPolicy,
};
